export default {
  tasks: "Tasks",
}